import Vue from 'vue';

class EventBus {
  constructor() {
    this.vueInstance = new Vue();
  }

  emit(event, payload) {
    this.vueInstance.$emit(event, payload);
  }

  on(event, callback) {
    this.vueInstance.$on(event, callback);
  }

  off(event, callback) {
    this.vueInstance.$off(event, callback);
  }

  offAll(event) {
    this.vueInstance.$off(event);
  }
}

export default new EventBus();
